import React from 'react';

const FileGridItem = ({ file, handleFileClick }) => {
	return (
		<div className="file-grid__item">
			<h3 className="file-grid__item-title" dangerouslySetInnerHTML={{__html: file.title}} />
			<span className="file-grid__item-links">
				<a href={file.file} target="_blank" onClick={() => handleFileClick(file.id)}>View</a> 
				<span>|</span> 
				<a href={file.file} download onClick={() => handleFileClick(file.id)}>Download</a>
			</span>
			<div className="file-grid__item-icon">
				<span className="material-icons">insert_drive_file</span>
			</div>
		</div>
	); 
};

export default FileGridItem;


// WEBPACK FOOTER //
// ./src/components/common/files/FileGrid/FileGridItem.js